<script>
export default {
    props: {
        image: {
            type: Object,
            required: true
        },
    },
    computed: {
        height() {
            return this.image?.height;
        },
        width() {
            return this.image?.width;
        },
        src() {
            return this.image?.defaultSrc ?? this.image?.src;
        },
        sources() {
            return Object.entries(this.image)
                .map(([key, value]) => {
                    const matches = key.match(/^w([\d]+)$/);

                    if (value && matches?.[1]) {
                        return `${value} ${matches[1]}w`;
                    }

                    return false;
                })
                .filter(v => v);
        },
        webpSources() {
            return Object.entries(this.image)
                .map(([key, value]) => {
                    const matches = key.match(/^w([\d]+)_webp$/);

                    if (value && matches?.[1]) {
                        return `${value} ${matches[1]}w`;
                    }

                    return false;
                })
                .filter(v => v);
        },
        avifSources() {
            return Object.entries(this.image)
                .map(([key, value]) => {
                    const matches = key.match(/^w([\d]+)_avif$/);

                    if (value && matches?.[1]) {
                        return `${value} ${matches[1]}w`;
                    }

                    return false;
                })
                .filter(v => v);
        },
        srcset() {
            return this.sources?.join(',');
        },
        webpSrcset() {
            return this.webpSources?.join(',');
        },
        avifSrcset() {
            return this.avifSources?.join(',');
        },
    },
    render() {
        return this.$slots.default({
            height: this.height,
            width: this.width,
            src: this.src,
            srcset: this.srcset,
            avifSrcset: this.avifSrcset,
            webpSrcset: this.webpSrcset,
        });
    },
};
</script>
